




































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ServiceAgent from '../../../services/serviceAgent';
import GooglAuthHelper from '@/helpers/GoogleAuthHelper';
import EventBus from '@/services/eventBus';

const serviceAgent = new ServiceAgent();
const googlAuthHelper = new GooglAuthHelper();

@Component
export default class Login extends Vue {
    @Prop() successSignInCallback!: Function;

    email = '';

    password = '';

    response= '';

    dialog = false;

    inProgress = false;

    formValid = false;

    validationRules = {
        required: (v: any) => !!v || 'Field is required',
        emailValidate: (v: any) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    }

    async loginSubmit() {
        (this.$refs.form as any).validate();
        if (!this.formValid) return;

        EventBus.$emit('showLoader', true);

        const self = this;

        serviceAgent.Login(this.email, this.password).then(() => {
            self.successSignInCallback();
        }).catch(() => {
            EventBus.$emit('openSnackbar', { snackbarText: 'Incorrect Email or Password. Please try again', snackbarSuccess: false });

            EventBus.$emit('showLoader', false);
        });
    }
}
